import { get } from "../apiClient";

export const featureFlagFetcher = async () => {
  const result = await get("player", "/api/v1/capabilities", {});
  return result;
};
